import { IoChevronBackSharp } from 'react-icons/io5';

import IconButton from 'components/ui/IconButton';

const HomeButton = () => {
  return (
    <a href="/workspace">
      <IconButton $size={40} $hasRadius>
        <IoChevronBackSharp />
      </IconButton>
    </a>
  );
};

export default HomeButton;
